import { createPortal } from "react-dom";
import { ShoppingBasket } from "lucide-react";
import { useCart, cartCount } from "../../lib/cart";

export const CartButton = ({ onClick }) => {
  const items = useCart();
  const n = cartCount(items);
  if (!n) return null;
  return createPortal(
    <button
      type="button"
      onClick={onClick}
      data-testid="shop-cart-button"
      aria-label={`Open basket, ${n} item${n === 1 ? "" : "s"}`}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-[#4B3A2F] text-[#F9F6F0] pl-4 pr-5 py-3 page-shadow hover:bg-[#3a2c23] transition-colors duration-300"
    >
      <ShoppingBasket size={18} />
      <span className="text-xs uppercase tracking-[0.2em]">Basket</span>
      <span className="ml-1 rounded-full bg-[#D62839] text-white text-xs w-6 h-6 flex items-center justify-center" data-testid="shop-cart-count">
        {n}
      </span>
    </button>,
    document.body,
  );
};
